/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiCampaignsSortBy = (typeof GetApiCampaignsSortBy)[keyof typeof GetApiCampaignsSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCampaignsSortBy = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    campaignStatus: 'campaignStatus',
    campaignType: 'campaignType',
    messageType: 'messageType',
    isActive: 'isActive',
} as const;
